module.exports = __webpack_public_path__ + "static/media/iphone-matchmaking.1afdbdd6.png";